import PosthogService from '~/services/posthog/PosthogService';

/**
 * Fires when a user clicks the shift-request action in the sidebar menu
 * Event: dental_portal:menu_bar:shift_request_clicked
 */
export function fireMenuBarShiftRequestClicked(): void {
  PosthogService.getInstance().track('dental_portal:menu_bar:shift_request_clicked');
}
